module.exports = __webpack_public_path__ + "img/pinterest-logo.f28c7bd0.svg";